import { createSelector } from 'reselect';

const getNotification = state => state.notification;

const NotificationSelectors = {
    makeSettings: createSelector([getNotification], notification => notification.settings),
};

export default NotificationSelectors;
